export const NO_PROFILES_DATA = "Sorry, we couldn't find any profiles with this search criteria.";
export const CREATE_NEW_PROFILE = "Create New Profile";